import { and, i18nScope, role } from '../condition.js';
import type { ProductMenuDef } from '../type.js';

/**
 * Speak の L2 メニュー定義。
 * 出典: navigation-v5/src/constants/level2/speak.ts
 *
 * L1 は実際の Speak アクセス制御と同じ `SPEAK.view` を要求する。
 * L2 は L1 で認可済みのため `i18n(scope=false)` のみとする
 * (v5 の `!plugin:righttouch_qant_global_nav` 排他ゲートは v2 では省略)。
 *
 * v5 の `isOther: true` グループ (OUTBOUND) は、v2 では「1 メニュー + popoverMenus」で表現する。
 */
export const QANT_SPEAK_MENU = {
  product: {
    name: 'speak',
    icon: 'qantSpeak',
    label: { ja: 'スピーク', en: 'Speak' },
    description: { ja: 'ボイスボット作成・運用', en: 'Automated Voice Interactions' },
  },
  condition: and(i18nScope(false), role('SPEAK', 'view')),
  menuGroups: {
    BASIC: {
      name: 'basic',
      menus: {
        DASHBOARD: {
          name: 'dashboard',
          icon: 'issuesDashboard',
          label: { ja: 'ダッシュボード', en: 'Dashboard' },
          path: { host: 'karte-io', path: '/speak/' },
          condition: i18nScope(false),
        },
        PHONE: {
          name: 'phone',
          icon: 'issuesConnectBoard',
          label: { ja: 'ダイヤル', en: 'Phone' },
          path: { host: 'karte-io', path: '/speak/phones' },
          condition: i18nScope(false),
        },
        FLOW: {
          name: 'flow',
          icon: 'issuesScenario',
          label: { ja: '通話フロー', en: 'Flow' },
          path: { host: 'karte-io', path: '/speak/flows' },
          condition: i18nScope(false),
        },
        SERVICE_LOG: {
          name: 'serviceLog',
          icon: 'issuesSupportSite',
          label: { ja: '応対ログ', en: 'Call History' },
          path: { host: 'karte-io', path: '/speak/logs' },
          condition: i18nScope(false),
        },
        ISSUE: {
          name: 'issue',
          icon: 'burst',
          label: { ja: '課題', en: 'Issue' },
          path: { host: 'karte-io', path: '/speak/issues' },
          condition: i18nScope(false),
        },
      },
    },
    SETTINGS: {
      name: 'settings',
      menus: {
        SETTINGS: {
          name: 'settings',
          icon: 'setting',
          label: { ja: '設定', en: 'Settings' },
          path: { host: 'karte-io', path: '/speak/settings' },
          condition: i18nScope(false),
        },
      },
    },
    OUTBOUND: {
      name: 'outbound',
      menus: {
        OUTBOUND: {
          icon: 'other',
          name: 'outbound',
          label: { ja: 'アウトバウンド', en: 'Outbound' },
          condition: i18nScope(false),
          popoverMenus: {
            DEFAULT: {
              name: 'default',
              items: {
                CAMPAIGN: {
                  name: 'campaign',
                  label: { ja: '施策', en: 'Campaign' },
                  path: { host: 'karte-io', path: '/speak/outbound/plans' },
                  condition: i18nScope(false),
                },
                LIST: {
                  name: 'list',
                  label: { ja: 'リスト', en: 'List' },
                  path: { host: 'karte-io', path: '/speak/outbound/call-lists' },
                  condition: i18nScope(false),
                },
              },
            },
          },
        },
      },
    },
  },
} as const satisfies ProductMenuDef;
